import { render } from "./InputRadio.vue?vue&type=template&id=0f928a6b&scoped=true"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"

import "./InputRadio.vue?vue&type=style&index=0&id=0f928a6b&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f928a6b"]])

export default __exports__